import axios from 'axios'

export default {
  update (id, data) {
    axios.patch('/api/v2/zone_profile_instances/' + id, data,
        {
          headers: {'Content-Type': 'application/merge-patch+json'}
        })
  },
  updateField (id, data) {
    axios.patch('/api/v2/field_profile_instances/' + id, data,
        {
          headers: {'Content-Type': 'application/merge-patch+json'}
        })
  }
}
